export default __webpack_public_path__ + "static/media/DSC_9112.6927f53c.jpg";